import React, { memo, useState, useRef, useEffect, useContext, MouseEvent } from 'react'
import { ThemeContext } from 'styled-components'
import { canUseDom } from '../utils'
import { createGolNonContentDataAttributes } from '../tracking'
import { trackEvent, isBlackFriday } from '../ComponentHelper'
import { StyledContainer, StyledCopy, StyledSeoSeeMoreLess } from './Seo.styles'
import { SeoProps } from './types'

const Seo = ({ bodyCopy = '', collapsible = true }: SeoProps): React.ReactElement => {
  const [isCollapsed, setIsCollapsed] = useState(true)
  const [seoHeight, setSeoHeight] = useState({})
  const targetRef = useRef(null)
  const theme = useContext(ThemeContext)
  const isSainsburys = theme?.channel === 'sainsburys'
  const ctaCopy = 'Read more'

  const copyMarkup = () => ({
    __html: isSainsburys ? bodyCopy.replace(/h3/g, 'h3 class=ln-u-display-2') : bodyCopy // this is to mitigate the large font sizes on Luna, should be reverted after they've addressed
  })

  const addGolTracking = (evt: MouseEvent<HTMLElement>) => {
    const dataAttributes = createGolNonContentDataAttributes(
      'link',
      'click',
      'cta link',
      `C007-NA-${ctaCopy.toLowerCase()}`,
      'interaction'
    )
    Object.keys(dataAttributes).forEach((attribute) =>
      evt.currentTarget.setAttribute(attribute, dataAttributes[attribute])
    )
  }

  const toggleSeo = (evt: MouseEvent<HTMLElement>) => {
    if (canUseDom() && isBlackFriday(window) && isCollapsed) {
      trackEvent(
        {
          eventInfo: {
            eventName: 'bf_wibf_seeMore',
            eventAction: 'What Is Black Friday See More'
          }
        },
        window
      )
    }
    addGolTracking(evt)
    setIsCollapsed(!isCollapsed)
  }

  useEffect(() => {
    setSeoHeight(targetRef.current.getBoundingClientRect().height)
  }, [])

  const isValidCollapsible = collapsible && seoHeight > 150
  return (
    <StyledContainer data-test='seo'>
      <StyledCopy
        isCollapsed={isCollapsed}
        isValidCollapsible={isValidCollapsible}
        data-test={`seo-copy-collapsed-${isCollapsed}`}
      >
        <div data-test='seo-copy' ref={targetRef} dangerouslySetInnerHTML={copyMarkup()} />
      </StyledCopy>
      {isValidCollapsible && (
        <button type='button' onClick={(evt) => toggleSeo(evt)}>
          <StyledSeoSeeMoreLess data-test='seo-see-more-less'>
            <strong>{isCollapsed ? ctaCopy : 'Show less'}</strong>
            <span />
          </StyledSeoSeeMoreLess>
        </button>
      )}
    </StyledContainer>
  )
}

export default memo(Seo)
